import React, { useState } from "react";
import Button from "../Button";
import Modal from "../Modal";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import { InputXLS } from "../InputXLS";
import { toast } from "react-toastify";

export const ModalUpdateStockBulk = ({ show, close, refresh }) => {
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [importResult, setImportResult] = useState(null);

    const clean = () => {
        setFile(null);
        setImportResult(null);
    };

    const getSpreadsheetTemplate = () => {
        setLoading(true);
        api.get(`/product/stock/export`, {
            responseType: 'blob'
        })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'produtos_estoque.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
        .catch(error => {
            renderError(error);
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const storeDatasheet = () => {
        if (!file) {
            toast.error('Por favor, selecione uma planilha.');
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append('file', file);

        api.post('/product/stock/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then(response => {
            setImportResult(response.data);
            
            const updatedCount = response.data.updated || 0;
            const errorCount = response.data.errors ? response.data.errors.length : 0;
            
            // Verificar se nenhum registro foi processado
            if (updatedCount === 0) {
                toast.error('Nenhum registro foi processado. Verifique a planilha e tente novamente.');
            } else if (errorCount > 0) {
                // Sucesso parcial - alguns registros foram processados, mas há erros
                toast.warning(`Importação concluída com erros. ${errorCount} linhas com erros.`);
            } else {
                // Sucesso total - todos os registros foram processados
                toast.success(`Estoque atualizado com sucesso! ${updatedCount} linhas processadas.`);
                clean();
                if (refresh) refresh();
                if(close) close();
            }
        })
        .catch(error => {
            if (error.response?.data?.errors) {
                setImportResult(error.response.data);
                const updatedCount = error.response.data.updated || 0;
                if (updatedCount === 0) {
                    toast.error('Nenhum registro foi processado. Verifique os erros abaixo.');
                } else {
                    toast.error(`Importação falhou. ${updatedCount} linhas processadas.`);
                }
            } else {
                renderError(error);
            }
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const handleClose = () => {
        clean();
        close();
    };

    return (
        <Modal
            title="Atualizar estoque em massa"
            show={show}
            close={handleClose}
            footer={
                <Button
                    type="primary"
                    size="small"
                    text="Enviar e atualizar"
                    svg="save-white"
                    action={storeDatasheet}
                    loading={loading}
                    disabled={!file}
                />
            }
        >
            <div className="section">
                <Button
                    type="primary"
                    text="Baixar planilha modelo"
                    svg="export"
                    full={true}
                    action={getSpreadsheetTemplate}
                    loading={loading}
                    style={{ marginBottom: '20px' }}
                />
                
                <InputXLS
                    label="Planilha de estoque"
                    file={file}
                    changeFile={setFile}
                    description="Selecione a planilha com o estoque das variações"
                />
            </div>
            
            {!importResult &&
                <div className="alert-warning" style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#fff3cd', border: '1px solid #ffeaa7', borderRadius: '4px' }}>
                    <p style={{ margin: 0, color: '#856404' }}>
                        <strong>Atenção:</strong> A atualização é apenas para produtos cadastrados manualmente, não sendo possível a atualização de produtos cadastrados via integração com os fornecedores.
                    </p>
                </div>
            }

            {importResult && importResult.errors && importResult.errors.length > 0 && (
                <div className="alert-danger" style={{ padding: '15px', backgroundColor: '#f8d7da', border: '1px solid #f5c6cb', borderRadius: '4px' }}>
                    <p style={{ margin: '0 0 10px 0', color: '#721c24' }}>
                        <strong>Erros encontrados:</strong>
                    </p>
                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                        {importResult.errors.map((error, index) => (
                            <li key={index} style={{ color: '#721c24', marginBottom: '5px' }}>
                                <strong>Linha {error.line}:</strong> {error.message} 
                                {error.sku && ` (SKU: ${error.sku})`}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </Modal>
    );
};

export default ModalUpdateStockBulk;